export default {
  LIST_FETCHED: 'JOURNEY_FETCHED',
  LIST_LOAD: 'JOURNEY_LOAD',
  ITEM_DETAIL: 'JOURNEY_DETAIL',
  BUTTON_LOAD: 'JOURNEY_BUTTON_LOAD',
  SUBSCRIBED: 'JOURNEY_SUBSCRIBED',
  RANKING_FETCHED: 'JOURNEY_RANKING_FETCHED',
  RANKING_LOAD: 'JOURNEY_RANKING_LOAD',
  LIST_ERROR: 'JOURNEY_LIST_ERROR',
  RANKING_ERROR: 'JOURNEY_RANKING_ERROR',
};
